module.exports = __webpack_public_path__ + "static/img/orderlist_feedback@3x.7475103.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/orderlist_feedback@3x.png
// module id = qiMl
// module chunks = 1